const NorwayFlag = () => (
  <svg width="16" height="12" viewBox="0 0 30 20" style={{ marginRight: '4px', verticalAlign: 'middle' }}>
    <rect width="30" height="20" fill="#BA0C2F"/>
    <rect x="12" width="6" height="20" fill="#FFFFFF"/>
    <rect y="8" width="30" height="4" fill="#FFFFFF"/>
    <rect x="13" width="4" height="20" fill="#00205B"/>
    <rect y="9" width="30" height="2" fill="#00205B"/>
  </svg>
);

export default NorwayFlag;